import React from 'react';
import ruecken from './assets/ruecken/ruecken_1.webp';
import { useLanguage } from './LanguageContext';
import OptimizedImage from './components/OptimizedImage';

const Back = () => {
  const { t } = useLanguage();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'Sora, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '1rem'
  };

  const contentStyle = {
    width: '100%',
    textAlign: 'center',
    paddingBlock: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const headingStyle1 = {
    color: '#666666',
    fontWeight: '500',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.8rem',
    marginBottom: '1rem',
    textAlign: 'center'
  };

  const headingStyle2 = {
    color: '#666666',
    fontWeight: '300',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.2rem',
    marginBottom: '1rem',
    textAlign: 'center'
  };

  const textStyle = {
    color: '#666666',
    lineHeight: '1.6',
    fontWeight: '300',
    fontSize: '1rem',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
  };

  const imageContainerStyle = {
    width: '100%',
    maxWidth: '1200px',
    height: '400px',
    overflow: 'hidden',
    borderRadius: '5px',
    marginBottom: '1rem',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  };

  return (
    <section id="ruecken" style={containerStyle}>
      <style>{`
        .back-titles {
          width: 100%;
          text-align: center;
          margin-bottom: 1rem;
        }
        .back-layout {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
        .back-image-container {
          width: 100%;
          max-width: 1200px;
          overflow: hidden;
          border-radius: 5px;
          margin-bottom: 1rem;
        }
        .back-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }
        .back-content {
          width: 100%;
        }
        @media (min-width: 700px) {
          .back-layout {
            flex-direction: row;
            align-items: stretch;
            gap: 40px;
            min-height: 400px;
            width: 100%;
          }
          .back-image-container {
            width: 50%;
            min-width: 300px;
            max-width: none;
            height: auto;
            margin-bottom: 0;
            display: flex;
            align-items: stretch;
            border-radius: 5px;
          }
          .back-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            border-radius: 5px;
          }
          .back-content {
            width: 50%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `}</style>
      <div className="back-titles">
        <h2 style={headingStyle2}>{t('speciality')}</h2>
        <h1 style={headingStyle1}>{t('yourBack')}</h1>
      </div>
      <div className="back-layout">
        <div className="back-image-container">
          <OptimizedImage src={ruecken} alt="Rückenbehandlung" className="back-image" />
        </div>
        <div className="back-content">
        <p style={textStyle}>
          {t('backText')}
        </p>
      </div>
      </div>
    </section>
  );
};

export default Back; 